import useSWR from 'swr';
import { MerchantDetail } from '../../../interfaces/merchants';
import { apiRoot } from '../../../utils/apiroot';
import securedAxios from '../../../utils/secured-axios';

export const useMerchantDetail = (merchantPublicId: string) => {
  const swrKey = ['merchants', merchantPublicId];
  const fetcher = async () => {
    const { data } = await securedAxios.get<MerchantDetail>(
      `${apiRoot()}/merchants/${merchantPublicId}`,
    );

    return data;
  };

  const { data, error, isValidating } = useSWR(swrKey, fetcher);

  return { data, error, isValidating };
};
